<div style="display: block">
    <canvas baseChart 
    [data]="doughnutChartData"
    [labels]="doughnutChartLabels"
    [colors]="doughnutcolors"
    [options]="options"
    [chartType]="doughnutChartType">
  </canvas>
  <!-- [data]="doughnutChartData" -->
  </div>